var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('common-table',{ref:"table",attrs:{"form-fields":_vm.formFields,"table-columns":_vm.tableColumns,"url":_vm.url,"searchs":_vm.searchs,"permission":_vm.permission,"operate":_vm.operate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }